export default "__VITE_ASSET__BMzy5A2D__"